import helper from '../../../helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('dashboardCommerciali');
export const actions = helper.createActions('dashboardCommerciali', actionTypes);